import { ref, watch } from 'vue'
import { useFrontEndDataQuery } from '../queries/useFrontEndDataQuery'
import { DropdownOption } from '@/api/contracts/models'

export function useGeoScopes() {
   const { data: frontendData } = useFrontEndDataQuery()
   const result = ref<undefined | DropdownOption[]>(undefined)

   const setGeoScopes = () => {
      result.value = frontendData.value!.geoScopes
   }

   watch(
      [frontendData],
      () => {
         if (frontendData.value) {
            setGeoScopes()
         }
      },
      { immediate: true, deep: true }
   )

   return result
}
